import { all, call } from 'redux-saga/effects';

export default sagas =>
  function*() {
    yield all(sagas.map(([saga, ...params]) => call(saga, ...params)));
  };



//////////////////
// WEBPACK FOOTER
// ./server/utils/waitAll.js
// module id = 747
// module chunks = 9